// prettier/prettier
import 'react-app-polyfill/stable';
// prettier/prettier
import * as Sentry from '@sentry/react';
import "antd-mobile/es/global";
import 'globalthis/auto'
import ReactDOM from "react-dom/client";
import { App } from "./app";
import { isMobile } from "./libs/detect";
import { LogAppInfo } from "./libs/logger";
import "./libs/sentry";
import reportWebVitals from "./reportWebVitals";
import "./styles/index.scss";
import { setDeviceInfo } from "./utils/request";

// @ts-ignore
if (window.h5p) {
  // @ts-ignore
  window.h5p.hook(async ({ schemaArguments, uuid, appid,appVer: appVer, system, version, model } = {}) => {
    try {
      window.plus &&
        Sentry.captureMessage(
          `user uuid:${uuid} appid:${appid} system:${system} version:${version} model:${model}`,
          "info"
        );
      // H5+ 网络请求会替换window原生请求
      setDeviceInfo({ uuid, system, version, model });
      // @ts-ignore
      window._appVer = appVer;
      // 关闭启动页
      // @ts-ignore
      if (window.h5p && window.h5p.closeSplash) window.h5p.closeSplash();


      try {
        // 测试套件
        const debug = localStorage.getItem("debug");
        if (debug) {
          const script = document.createElement("script");
          script.setAttribute("id", "eruda-script");
          script.type = "text/javascript";
          script.src = "js/eruda.js";
          script.onload = function () {

            // @ts-ignore
            window.eruda.init();
          };
          document.body && document.body.append && document.body.append(script);
        }
      } catch (error) {
        console.error("eruda amount error:", error);
      }
    } catch (e) {
      console.error('h5p error',e);
      // 关闭启动页
      // @ts-ignore
      if (window.h5p && window.h5p.closeSplash) window.h5p.closeSplash();
      Sentry.captureException(e, {
        tags: {
          capture_fn: "hook",
        },
      });
    }
  });
} else {
  setDeviceInfo({});
  Sentry.captureMessage(
    `not h5p`,
    "info"
  );
}




// 输出一些基本信息到控制台
console.info(
  ...LogAppInfo.info(`
    环境:${process.env.REACT_APP_ENV}
    APP?:${process.env.REACT_APP_HBUILDER ? "yes" : "no"}
    VER:${process.env.REACT_APP_VER}
    isMobile:${isMobile}
`)
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
